import { render, staticRenderFns } from "./BaseEditorTemplate.vue?vue&type=template&id=27c6428c&"
import script from "./BaseEditorTemplate.vue?vue&type=script&lang=ts&"
export * from "./BaseEditorTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports